import React from 'react';
import './ServicesSection.css';
import soft from '../soft.jpeg';
import app from '../app.jpeg';
import digital from '../digital.jpeg';
import web from '../web.jpeg';

const ServicesSection = () => {
  const services = [
    {
      number: 1,
      title: "Software Development",
      description: "Transform ideas into powerful software solutions with cutting-edge development. Let’s build technology that speaks for your brand.",
      image: soft
    },
    {
      number: 2,
      title: "Web Development",
      description: "Transform your vision into a stunning, user-friendly website. Experience seamless functionality and cutting-edge design.",
      image: web
    },
    {
      number: 3,
      title: "Digital Marketing",
      description: "Boost your online presence with strategic digital marketing. Engage your audience, drive traffic, and achieve your goals.",
      image: digital
    },
    {
      number: 4,
      title: "App Development",
      description: "Create engaging and intuitive apps tailored to your needs. Enhance user experience and expand your digital reach.",
      image: app
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <h2 className="services-title">
          Empowering Your Brand with Comprehensive Solutions
        </h2>
        <div className="services-list">
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <div className="service-number">{service.number}</div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
              {/* <div className="service-arrow">
                <span>↑</span>
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 